export const REQUEST_STATE = 'REQUEST_STATE'
export const SET_ERROR = 'SET_ERROR'
export const SET_LOADING = 'SET_LOADING'

export const LOGOUT = 'LOGOUT'
export const CORE_GET_SYSTEM_INFO_REQUEST = "CORE_GET_SYSTEM_INFO_REQUEST"
export const CORE_GET_SYSTEM_INFO_SUCCESS = "CORE_GET_SYSTEM_INFO_SUCCESS"
export const CORE_GET_SYSTEM_INFO_FAILURE = "CORE_GET_SYSTEM_INFO_FAILURE"

export const CORE_GET_USERS_REQUEST = 'CORE_GET_USERS_REQUEST'
export const CORE_GET_USERS_SUCCESS = 'CORE_GET_USERS_SUCCESS'
export const CORE_GET_USERS_FAILURE = 'CORE_GET_USERS_FAILURE'

export const CORE_GET_USER_INFO_REQUEST = 'CORE_GET_USER_INFO_REQUEST'
export const CORE_GET_USER_INFO_SUCCESS = 'CORE_GET_USER_INFO_SUCCESS'
export const CORE_GET_USER_INFO_FAILURE = 'CORE_GET_USER_INFO_FAILURE'

export const CORE_CHANGE_USER_NPI_PERMIT_REQUEST = 'CORE_CHANGE_USER_NPI_PERMIT_REQUEST'
export const CORE_CHANGE_USER_NPI_PERMIT_SUCCESS = 'CORE_CHANGE_USER_NPI_PERMIT_SUCCESS'
export const CORE_CHANGE_USER_NPI_PERMIT_FAILURE = 'CORE_CHANGE_USER_NPI_PERMIT_FAILURE'

export const CORE_CHANGE_USER_ADMIN_PERMIT_REQUEST = 'CORE_CHANGE_USER_ADMIN_PERMIT_REQUEST'
export const CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS = 'CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS'
export const CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE = 'CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE'


export const CORE_SET_USER_APPROVE_REQUEST = "CORE_SET_USER_APPROVE_REQUEST"
export const CORE_SET_USER_APPROVE_SUCCESS = "CORE_SET_USER_APPROVE_SUCCESS"
export const CORE_SET_USER_APPROVE_FAILURE = "CORE_SET_USER_APPROVE_FAILURE"

export const CORE_SET_USER_SUBMIT_REQUEST = "CORE_SET_USER_SUBMIT_REQUEST"
export const CORE_SET_USER_SUBMIT_SUCCESS = "CORE_SET_USER_SUBMIT_SUCCESS"
export const CORE_SET_USER_SUBMIT_FAILURE = "CORE_SET_USER_SUBMIT_FAILURE"

//AUTH
export const CORE_AUTH_VERIFY_REQUEST = 'CORE_AUTH_VERIFY_REQUEST'
export const CORE_AUTH_VERIFY_SUCCESS = 'CORE_AUTH_VERIFY_SUCCESS'
export const CORE_AUTH_VERIFY_FAILURE = 'CORE_AUTH_VERIFY_FAILURE'

export const CORE_GET_REQUEST_INFO_REQUEST = "CORE_GET_REQUEST_INFO_REQUEST"
export const CORE_GET_REQUEST_INFO_SUCCESS = "CORE_GET_REQUEST_INFO_SUCCESS"
export const CORE_GET_REQUEST_INFO_FAILURE = "CORE_GET_REQUEST_INFO_FAILURE"


//TRANSFER
export const CORE_GET_ALL_TRANSFERS_REQUEST = "CORE_GET_ALL_TRANSFERS_REQUEST"
export const CORE_GET_ALL_TRANSFERS_SUCCESS = "CORE_GET_ALL_TRANSFERS_SUCCESS"
export const CORE_GET_ALL_TRANSFERS_FAILURE = "CORE_GET_ALL_TRANSFERS_FAILURE"

export const CORE_GET_TRANSFER_BY_ID_REQUEST = "CORE_GET_TRANSFER_BY_ID_REQUEST"
export const CORE_GET_TRANSFER_BY_ID_SUCCESS = "CORE_GET_TRANSFER_BY_ID_SUCCESS"
export const CORE_GET_TRANSFER_BY_ID_FAILURE = "CORE_GET_TRANSFER_BY_ID_FAILURE"

export const CORE_CREATE_TRANSFER_REQUEST = "CORE_CREATE_TRANSFER_REQUEST"
export const CORE_CREATE_TRANSFER_SUCCESS = "CORE_CREATE_TRANSFER_SUCCESS"
export const CORE_CREATE_TRANSFER_FAILURE = "CORE_CREATE_TRANSFER_FAILURE"

export const CORE_TRANSFER_ITEM_REQUEST = "CORE_TRANSFER_ITEM_REQUEST"
export const CORE_TRANSFER_ITEM_SUCCESS = "CORE_TRANSFER_ITEM_SUCCESS"
export const CORE_TRANSFER_ITEM_FAILURE = "CORE_TRANSFER_ITEM_FAILURE"

export const CORE_RECEIVE_ITEM_REQUEST = "CORE_RECEIVE_ITEM_REQUEST"
export const CORE_RECEIVE_ITEM_SUCCESS = "CORE_RECEIVE_ITEM_SUCCESS"
export const CORE_RECEIVE_ITEM_FAILURE = "CORE_RECEIVE_ITEM_FAILURE"


//SETTINGS
export const CORE_GET_SETTINGS_REQUEST = "CORE_GET_SETTINGS_REQUEST"
export const CORE_GET_SETTINGS_SUCCESS = "CORE_GET_SETTINGS_SUCCESS"
export const CORE_GET_SETTINGS_FAILURE = "CORE_GET_SETTINGS_FAILURE"

export const CORE_UPSERT_SETTINGS_REQUEST = "CORE_UPSERT_SETTINGS_REQUEST"
export const CORE_UPSERT_SETTINGS_SUCCESS = "CORE_UPSERT_SETTINGS_SUCCESS"
export const CORE_UPSERT_SETTINGS_FAILURE = "CORE_UPSERT_SETTINGS_FAILURE"


//QR Tag
//RM Tag
export const CORE_GET_RM_TAG_REQUEST = "CORE_GET_RM_TAG_REQUEST"
export const CORE_GET_RM_TAG_SUCCESS = "CORE_GET_RM_TAG_SUCCESS"
export const CORE_GET_RM_TAG_FAILURE = "CORE_GET_RM_TAG_FAILURE"

export const CORE_CREATE_RM_TAG_REQUEST = "CORE_CREATE_RM_TAG_REQUEST"
export const CORE_CREATE_RM_TAG_SUCCESS = "CORE_CREATE_RM_TAG_SUCCESS"
export const CORE_CREATE_RM_TAG_FAILURE = "CORE_CREATE_RM_TAG_FAILURE"

// PD Tag
export const CORE_GET_PD_TAG_REQUEST = "CORE_GET_PD_TAG_REQUEST"
export const CORE_GET_PD_TAG_SUCCESS = "CORE_GET_PD_TAG_SUCCESS"
export const CORE_GET_PD_TAG_FAILURE = "CORE_GET_PD_TAG_FAILURE"

export const CORE_CREATE_PD_TAG_REQUEST = "CORE_CREATE_PD_TAG_REQUEST"
export const CORE_CREATE_PD_TAG_SUCCESS = "CORE_CREATE_PD_TAG_SUCCESS"
export const CORE_CREATE_PD_TAG_FAILURE = "CORE_CREATE_PD_TAG_FAILURE"

// Delivery Tag
export const CORE_GET_DELIVERY_TAG_REQUEST = "CORE_GET_DELIVERY_TAG_REQUEST"
export const CORE_GET_DELIVERY_TAG_SUCCESS = "CORE_GET_DELIVERY_TAG_SUCCESS"
export const CORE_GET_DELIVERY_TAG_FAILURE = "CORE_GET_DELIVERY_TAG_FAILURE"

export const CORE_CREATE_DELIVERY_TAG_REQUEST = "CORE_CREATE_DELIVERY_TAG_REQUEST"
export const CORE_CREATE_DELIVERY_TAG_SUCCESS = "CORE_CREATE_DELIVERY_TAG_SUCCESS"
export const CORE_CREATE_DELIVERY_TAG_FAILURE = "CORE_CREATE_DELIVERY_TAG_FAILURE"

// PO Receipt
export const CORE_GET_PO_RECEIPT_REQUEST = "CORE_GET_PO_RECEIPT_REQUEST"
export const CORE_GET_PO_RECEIPT_SUCCESS = "CORE_GET_PO_RECEIPT_SUCCESS"
export const CORE_GET_PO_RECEIPT_FAILURE = "CORE_GET_PO_RECEIPT_FAILURE"

export const CORE_CREATE_PO_RECEIPT_REQUEST = "CORE_CREATE_PO_RECEIPT_REQUEST"
export const CORE_CREATE_PO_RECEIPT_SUCCESS = "CORE_CREATE_PO_RECEIPT_SUCCESS"
export const CORE_CREATE_PO_RECEIPT_FAILURE = "CORE_CREATE_PO_RECEIPT_FAILURE"


// SO Pick
export const CORE_GET_LIST_SO_REQUEST = "CORE_GET_LIST_SO_REQUEST"
export const CORE_GET_LIST_SO_SUCCESS = "CORE_GET_LIST_SO_SUCCESS"
export const CORE_GET_LIST_SO_FAILURE = "CORE_GET_LIST_SO_FAILURE"


export const CORE_GET_SO_INFO_REQUEST = "CORE_GET_SO_INFO_REQUEST"
export const CORE_GET_SO_INFO_SUCCESS = "CORE_GET_SO_INFO_SUCCESS"
export const CORE_GET_SO_INFO_FAILURE = "CORE_GET_SO_INFO_FAILURE"

export const CORE_GET_SO_PICK_REQUEST = "CORE_GET_SO_PICK_REQUEST"
export const CORE_GET_SO_PICK_SUCCESS = "CORE_GET_SO_PICK_SUCCESS"
export const CORE_GET_SO_PICK_FAILURE = "CORE_GET_SO_PICK_FAILURE"

export const CORE_CREATE_SO_PICK_REQUEST = "CORE_CREATE_SO_PICK_REQUEST"
export const CORE_CREATE_SO_PICK_SUCCESS = "CORE_CREATE_SO_PICK_SUCCESS"
export const CORE_CREATE_SO_PICK_FAILURE = "CORE_CREATE_SO_PICK_FAILURE"


//Raw Material
export const CORE_GET_ALL_AX_RAW_MAT_REQUEST = "CORE_GET_ALL_AX_RAW_MAT_REQUEST"
export const CORE_GET_ALL_AX_RAW_MAT_SUCCESS = "CORE_GET_ALL_AX_RAW_MAT_SUCCESS"
export const CORE_GET_ALL_AX_RAW_MAT_FAILURE = "CORE_GET_ALL_AX_RAW_MAT_FAILURE"

export const CORE_GET_ALL_RAW_MATERIAL_REQUEST = "CORE_GET_ALL_RAW_MATERIAL_REQUEST"
export const CORE_GET_ALL_RAW_MATERIAL_SUCCESS = "CORE_GET_ALL_RAW_MATERIAL_SUCCESS"
export const CORE_GET_ALL_RAW_MATERIAL_FAILURE = "CORE_GET_ALL_RAW_MATERIAL_FAILURE"

export const CORE_GET_RAW_MATERIAL_BY_ID_REQUEST = "CORE_GET_RAW_MATERIAL_BY_ID_REQUEST"
export const CORE_GET_RAW_MATERIAL_BY_ID_SUCCESS = "CORE_GET_RAW_MATERIAL_BY_ID_SUCCESS"
export const CORE_GET_RAW_MATERIAL_BY_ID_FAILURE = "CORE_GET_RAW_MATERIAL_BY_ID_FAILURE"

export const CORE_CREATE_RAW_MATERIAL_REQUEST = "CORE_CREATE_RAW_MATERIAL_REQUEST"
export const CORE_CREATE_RAW_MATERIAL_SUCCESS = "CORE_CREATE_RAW_MATERIAL_SUCCESS"
export const CORE_CREATE_RAW_MATERIAL_FAILURE = "CORE_CREATE_RAW_MATERIAL_FAILURE"

export const CORE_UPDATE_RAW_MATERIAL_REQUEST = "CORE_UPDATE_RAW_MATERIAL_REQUEST"
export const CORE_UPDATE_RAW_MATERIAL_SUCCESS = "CORE_UPDATE_RAW_MATERIAL_SUCCESS"
export const CORE_UPDATE_RAW_MATERIAL_FAILURE = "CORE_UPDATE_RAW_MATERIAL_FAILURE"

export const CORE_DELETE_RAW_MATERIAL_REQUEST = "CORE_DELETE_RAW_MATERIAL_REQUEST"
export const CORE_DELETE_RAW_MATERIAL_SUCCESS = "CORE_DELETE_RAW_MATERIAL_SUCCESS"
export const CORE_DELETE_RAW_MATERIAL_FAILURE = "CORE_DELETE_RAW_MATERIAL_FAILURE"

export const CORE_APPROVE_RAW_MATERIAL_REQUEST = "CORE_APPROVE_RAW_MATERIAL_REQUEST"
export const CORE_APPROVE_RAW_MATERIAL_SUCCESS = "CORE_APPROVE_RAW_MATERIAL_SUCCESS"
export const CORE_APPROVE_RAW_MATERIAL_FAILURE = "CORE_APPROVE_RAW_MATERIAL_FAILURE"

export const CORE_SEND_RAW_MATERIAL_REQUEST = "CORE_SEND_RAW_MATERIAL_REQUEST"
export const CORE_SEND_RAW_MATERIAL_SUCCESS = "CORE_SEND_RAW_MATERIAL_SUCCESS"
export const CORE_SEND_RAW_MATERIAL_FAILURE = "CORE_SEND_RAW_MATERIAL_FAILURE"

export const CORE_GET_ALL_RAW_MAT_REQUEST = "CORE_GET_ALL_RAW_MAT_REQUEST"
export const CORE_GET_ALL_RAW_MAT_SUCCESS = "CORE_GET_ALL_RAW_MAT_SUCCESS"
export const CORE_GET_ALL_RAW_MAT_FAILURE = "CORE_GET_ALL_RAW_MAT_FAILURE"



export const CORE_CREATE_PACK_ITEMS_REQUEST = "CORE_CREATE_PACK_ITEMS_REQUEST"
export const CORE_CREATE_PACK_ITEMS_SUCCESS = "CORE_CREATE_PACK_ITEMS_SUCCESS"
export const CORE_CREATE_PACK_ITEMS_FAILURE = "CORE_CREATE_PACK_ITEMS_FAILURE"


// Multi PD
export const CORE_GET_ALL_MULTI_PD_RAW_MATT_REQUEST = "CORE_GET_ALL_MULTI_PD_RAW_MATT_REQUEST"
export const CORE_GET_ALL_MULTI_PD_RAW_MATT_SUCCESS = "CORE_GET_ALL_MULTI_PD_RAW_MATT_SUCCESS"
export const CORE_GET_ALL_MULTI_PD_RAW_MATT_FAILURE = "CORE_GET_ALL_MULTI_PD_RAW_MATT_FAILURE"

export const CORE_GET_MULTI_PD_RAW_MATT_REQUEST = "CORE_GET_MULTI_PD_RAW_MATT_REQUEST"
export const CORE_GET_MULTI_PD_RAW_MATT_SUCCESS = "CORE_GET_MULTI_PD_RAW_MATT_SUCCESS"
export const CORE_GET_MULTI_PD_RAW_MATT_FAILURE = "CORE_GET_MULTI_PD_RAW_MATT_FAILURE"

export const CORE_GET_MULTI_PD_RAW_MATT_BY_ID_REQUEST = "CORE_GET_MULTI_PD_RAW_MATT_BY_ID_REQUEST"
export const CORE_GET_MULTI_PD_RAW_MATT_BY_ID_SUCCESS = "CORE_GET_MULTI_PD_RAW_MATT_BY_ID_SUCCESS"
export const CORE_GET_MULTI_PD_RAW_MATT_BY_ID_FAILURE = "CORE_GET_MULTI_PD_RAW_MATT_BY_ID_FAILURE"

export const CORE_CREATE_MULTI_PD_RAW_MATT_REQUEST = "CORE_CREATE_MULTI_PD_RAW_MATT_REQUEST"
export const CORE_CREATE_MULTI_PD_RAW_MATT_SUCCESS = "CORE_CREATE_MULTI_PD_RAW_MATT_SUCCESS"
export const CORE_CREATE_MULTI_PD_RAW_MATT_FAILURE = "CORE_CREATE_MULTI_PD_RAW_MATT_FAILURE"

export const CORE_DELETE_MULTI_PD_REQUEST = "CORE_DELETE_MULTI_PD_REQUEST"
export const CORE_DELETE_MULTI_PD_SUCCESS = "CORE_DELETE_MULTI_PD_SUCCESS"
export const CORE_DELETE_MULTI_PD_FAILURE = "CORE_DELETE_MULTI_PD_FAILURE"

export const CORE_APPROVE_MULTI_PD_REQUEST = "CORE_APPROVE_MULTI_PD_REQUEST"
export const CORE_APPROVE_MULTI_PD_SUCCESS = "CORE_APPROVE_MULTI_PD_SUCCESS"
export const CORE_APPROVE_MULTI_PD_FAILURE = "CORE_APPROVE_MULTI_PD_FAILURE"

export const CORE_SEND_MULTI_PD_REQUEST = "CORE_SEND_MULTI_PD_REQUEST"
export const CORE_SEND_MULTI_PD_SUCCESS = "CORE_SEND_MULTI_PD_SUCCESS"
export const CORE_SEND_MULTI_PD_FAILURE = "CORE_SEND_MULTI_PD_FAILURE"

// Rm Summary
export const CORE_GET_ALL_RM_SUMMARY_RAW_MATT_REQUEST = "CORE_GET_ALL_RM_SUMMARY_RAW_MATT_REQUEST"
export const CORE_GET_ALL_RM_SUMMARY_RAW_MATT_SUCCESS = "CORE_GET_ALL_RM_SUMMARY_RAW_MATT_SUCCESS"
export const CORE_GET_ALL_RM_SUMMARY_RAW_MATT_FAILURE = "CORE_GET_ALL_RM_SUMMARY_RAW_MATT_FAILURE"

export const CORE_GET_RM_SUMMARY_RAW_MATT_REQUEST = "CORE_GET_RM_SUMMARY_RAW_MATT_REQUEST"
export const CORE_GET_RM_SUMMARY_RAW_MATT_SUCCESS = "CORE_GET_RM_SUMMARY_RAW_MATT_SUCCESS"
export const CORE_GET_RM_SUMMARY_RAW_MATT_FAILURE = "CORE_GET_RM_SUMMARY_RAW_MATT_FAILURE"

export const CORE_GET_RM_SUMMARY_RAW_MATT_BY_ID_REQUEST = "CORE_GET_RM_SUMMARY_RAW_MATT_BY_ID_REQUEST"
export const CORE_GET_RM_SUMMARY_RAW_MATT_BY_ID_SUCCESS = "CORE_GET_RM_SUMMARY_RAW_MATT_BY_ID_SUCCESS"
export const CORE_GET_RM_SUMMARY_RAW_MATT_BY_ID_FAILURE = "CORE_GET_RM_SUMMARY_RAW_MATT_BY_ID_FAILURE"

export const CORE_CREATE_RM_SUMMARY_RAW_MATT_REQUEST = "CORE_CREATE_RM_SUMMARY_RAW_MATT_REQUEST"
export const CORE_CREATE_RM_SUMMARY_RAW_MATT_SUCCESS = "CORE_CREATE_RM_SUMMARY_RAW_MATT_SUCCESS"
export const CORE_CREATE_RM_SUMMARY_RAW_MATT_FAILURE = "CORE_CREATE_RM_SUMMARY_RAW_MATT_FAILURE"

export const CORE_DELETE_RM_SUMMARY_REQUEST = "CORE_DELETE_RM_SUMMARY_REQUEST"
export const CORE_DELETE_RM_SUMMARY_SUCCESS = "CORE_DELETE_RM_SUMMARY_SUCCESS"
export const CORE_DELETE_RM_SUMMARY_FAILURE = "CORE_DELETE_RM_SUMMARY_FAILURE"

export const CORE_APPROVE_RM_SUMMARY_REQUEST = "CORE_APPROVE_RM_SUMMARY_REQUEST"
export const CORE_APPROVE_RM_SUMMARY_SUCCESS = "CORE_APPROVE_RM_SUMMARY_SUCCESS"
export const CORE_APPROVE_RM_SUMMARY_FAILURE = "CORE_APPROVE_RM_SUMMARY_FAILURE"

export const CORE_SEND_RM_SUMMARY_REQUEST = "CORE_SEND_RM_SUMMARY_REQUEST"
export const CORE_SEND_RM_SUMMARY_SUCCESS = "CORE_SEND_RM_SUMMARY_SUCCESS"
export const CORE_SEND_RM_SUMMARY_FAILURE = "CORE_SEND_RM_SUMMARY_FAILURE"



// WEBPACK FOOTER //
// ./src/app/redux/types.js